import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryItemRequestPendingApproval } from "./thunk";

interface InitialStateType {
  itemRequestListPendingApproval: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: InitialStateType = {
  itemRequestListPendingApproval: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryItemRequestPendingSlice = createSlice({
  name: "InventoryItemRequestPending",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryItemRequestPendingApproval.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryItemRequestPendingApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.itemRequestListPendingApproval = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryItemRequestPendingApproval.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Pending Item Requests";
      });
  },
});

export default InventoryItemRequestPendingSlice.reducer;
